import React, { memo } from 'react';
import { TextStyle } from '@ticketmaster/global-design-system';

import styles from './portal.module.scss';
import { TicketModel } from '@/v2/models/ticketModel';

type Props = {
  ticket: TicketModel;
  entryGateLabel?: string;
};

const TicketPortal = ({ ticket, entryGateLabel }: Props) => {
  const label = entryGateLabel?.trim();

  return (
    <div>
      {ticket.exitPortal && (
        <div className={styles.ticketPortal}>
          <TextStyle.Blanc className={styles.ticketPortalText}>
            {label ? `${label}: ${ticket.exitPortal}` : ticket.exitPortal}
          </TextStyle.Blanc>
        </div>
      )}
    </div>
  );
};

export default memo(TicketPortal);
